export const  buildDateRangeConditions = (parsedDateRanges) => {
    if (!parsedDateRanges?.length) {
      return { 
        holidayDateConditions: [], 
        suspensionDateConditions: [],
        manualDtrDateConditions: [],
        leaveDateConditions: [],
        obDateConditions: [],
        timeoffDateConditions: []
      };
    }

    const holidayDateConditions = [];
    const suspensionDateConditions = [];
    const manualDtrDateConditions = [];
    const leaveDateConditions = [];
    const obDateConditions = [];
    const timeoffDateConditions = [];

    parsedDateRanges
      .filter((r) => r?.dateRangeQuery)
      .forEach(({ dateRangeQuery, parsed }) => {
        const { $gte, $lte } = dateRangeQuery;

        holidayDateConditions.push({ date: { $gte, $lte } });
        suspensionDateConditions.push({ dateFrom: { $lte }, dateTo: { $gte }});
        
        // Leave request conditions (overlapping range check)
        if (parsed?.startDate && parsed?.endDate) {
          leaveDateConditions.push({
            startdate: { $lte: parsed.endDate },
            enddate: { $gte: parsed.startDate },
          });
        }

        // Timeoff conditions (using parsed dates for date field)
        if (parsed?.startDate && parsed?.endDate) {
          timeoffDateConditions.push({
            date: { $gte: parsed.startDate, $lte: parsed.endDate },
          });
        }
       // Manual DTR conditions (nested array format for dateRange)
        const start = new Date($gte);
        const end = new Date($lte);
        
        if (start instanceof Date && !isNaN(start.getTime()) && 
            end instanceof Date && !isNaN(end.getTime())) {
          const validDates = [];
          let dateCursor = new Date(start);
          
          while (dateCursor <= end) {
            const dateStr = new Date(dateCursor).toISOString().split("T")[0];
            validDates.push(dateStr);
            dateCursor.setDate(dateCursor.getDate() + 1);
          }

          const adjustedLteDate = new Date(end);
          adjustedLteDate.setDate(adjustedLteDate.getDate() - 1);
          const adjustedLte = adjustedLteDate.toISOString().split("T")[0];

          manualDtrDateConditions.push({
            dateRange: { $elemMatch: { $elemMatch: { 0: { $lte: adjustedLte }, 1: { $gte: $gte } } }},
          });

          // OB Management conditions (flat array format for obDates)
          obDateConditions.push({
            obDates: { $in: validDates },
          });
        }
      });

    return { 
      holidayDateConditions, 
      suspensionDateConditions,
      manualDtrDateConditions,
      leaveDateConditions,
      obDateConditions,
      timeoffDateConditions
    };
  };

  export const buildHolidayWhere = (holidayDateConditions, orgOrSelectAll) => {
    const conditions = [{ $or: orgOrSelectAll }];
    if (holidayDateConditions.length > 0) {
      conditions.push({ $or: holidayDateConditions });
    }
    return conditions.length > 1 ? { $and: conditions } : conditions[0];
  };

  export const  buildSuspensionWhere = (suspensionDateConditions, orgOrSelectAll) => {
    const conditions = [
      { $or: orgOrSelectAll },
      { dateFrom: { $ne: null } },
      { dateTo: { $ne: null } },
    ];
    if (suspensionDateConditions.length > 0) {
      conditions.push({ $or: suspensionDateConditions });
    }
    return { $and: conditions };
  };
